var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTenantNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_725_404",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_725_404",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB90lEQVR4nO2dQUoDQRRE+wB6DPUObkT75wheQKS/uNd4GJPgNmdRbxRGekDQje6mKvR7UOsw9aZ7hqHJLwUAAAAAAAAAAABAxvXDRYm2LrXtSs39WGm7cpPPpd6fFzmXd6cl2lup7VAip6FT22GWc/V4opTxKS8i7PKhkdJXhv7iJ8v0lbL4M4NtavpDyGHZZ0q0F/ldGO5p6+WE9CUpv+A0T9ssKCT3+gtO7/SOEJJ6EQhJffkISX3hCEl9yQhJfbEISX2ZCDEoMBCiLy0Qoi8qEKIvJxCiLyQQoi8hjMK3rNRLQEjqi0dI6ss+KiHyYzm5bOyFjEYgxAuEmIEQMxBiBkLMQIgZCDEDIWbYC1m126ES7kLIhJAwvBFYIamXgJDUF4+Q1JeNkNQXfLRC1K+hK157fwsZjXBfIaMRCPECIWYgxAyEmIEQMxBiBkLMsBeiPtpZOUqq/24UhrFZIWRCSBjeCKyQ1EtASOqLR0jqyz4qIaMRCPECIWYgxAyEmIEQMxBiBkLMQIgZCDHDQkj/o3n1p4lwT3tdUgjjKuIfIX0u1WL0YSUMdJl8BrrMUpghUixmh3zTB1/1AVjyvTq9Utu7blJb/+F5diFj88rcQdvoZPyk75fzcMXcyo/l1MWzLbU9lcgztQYAAAAAAAAAAAAo4/IF16qWSbNDEs8AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantNotes);
export default __webpack_public_path__ + "static/media/tenantNotes.04ffce3cf31a97af529bf73da9004599.svg";
export { ForwardRef as ReactComponent };